function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata876"
}, /*#__PURE__*/React.createElement("useless", null, /*#__PURE__*/React.createElement("useless", {
  useless: ""
}, /*#__PURE__*/React.createElement("useless", null, "image/svg+xml"), /*#__PURE__*/React.createElement("useless", {
  useless: "http://purl.org/dc/dcmitype/StillImage"
}), /*#__PURE__*/React.createElement("useless", null))));

var _ref3 = /*#__PURE__*/React.createElement("defs", {
  id: "defs874"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "layer1"
}, /*#__PURE__*/React.createElement("path", {
  id: "path964-7",
  d: "m -0.389661,53.300057 c 5.023407,10e-7 9.729887,-2.526806 12.330077,-6.789062 2.60019,-4.262256 2.60019,-9.651807 0,-13.914063 C 9.340227,28.334677 4.633747,25.80787 -0.389661,25.80787 v 8.089844 c 2.30083,0 4.363847,1.171379 5.425779,2.912109 1.061931,1.74073 1.061932,3.747551 0,5.488281 -1.061932,1.74073 -3.124949,2.91211 -5.425779,2.91211 z"
}), /*#__PURE__*/React.createElement("rect", {
  ry: 0.00000359872,
  y: 35.331306,
  x: 11.841209,
  height: 7.8125,
  width: 16.31958,
  id: "rect962"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "layer3"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  id: "layer2"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "path4657",
  d: "M 79.13335,58.124449 64.91015,47.131047 c 0.05327,-0.570567 0.1055,-1.143183 0.1055,-1.728092 0,-11.448216 -10.22206,-15.707492 -15.035515,-31.941505 -0.81334,-2.948103 -5.064423,-3.085365 -5.986344,0 -1.589802,5.361483 -3.776807,9.419988 -5.991467,12.874119 L 18.865292,11.543852 C 18.15029,10.98865 17.119787,11.116694 16.564585,11.831696 l -2.011838,2.58855 c -0.555201,0.713976 -0.427157,1.743456 0.287845,2.299683 l 60.269084,46.580597 c 0.715,0.556226 1.74448,0.427157 2.300706,-0.287844 L 79.42222,60.42413 c 0.554177,-0.713976 0.426133,-1.743455 -0.28887,-2.299681 z M 28.958284,45.402955 c 0,10.083773 8.063741,18.242778 18.028688,18.242778 4.579901,0 8.744938,-1.73731 11.923517,-4.578876 L 30.875881,37.399652 c -1.168792,2.407241 -1.917597,4.952769 -1.917597,8.003303 z"
});

var SvgDehumid = function SvgDehumid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg870",
    role: "presentation",
    "aria-hidden": "true",
    viewBox: "0 0 80 80",
    focusable: "false",
    className: "MuiSvgIcon-root",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDehumid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dehumid.fff56ea1.svg";
export { ForwardRef as ReactComponent };